import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { TenantService } from '@services/tenant.service';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

/**
 * Tenant guard so we only go to URL if the tenant is present and exists.
 */
@Injectable({ providedIn: 'root' })
export class TenantGuard  {
  constructor(
    private router: Router,
    private tenantService: TenantService
  ) { }

  /**
   * Check if the childroute can be activated.
   * @param route Snapshot of the route to which we check the guard against.
   * @param state Snapshot of the state of router from which we get data for the guard check.
   */
  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.checkTenant(route);
  }

  /**
   * Check if the route can be activated.
   * @param route Snapshot of the route to which we check the guard against.
   * @param state Snapshot of the state of router from which we get data for the guard check.
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.checkTenant(route);
  }

  /*canLoad(route: Route): boolean {
    return this.getTenant(route);
  }*/

  /**
   * Perform the check if tenant exists from the tenant service.
   * @param route Snapshot of the route that is attempted to be activated.
   */
  private checkTenant(route: ActivatedRouteSnapshot): Observable<boolean> {
    const alias: string = this.tenantService.activeTenantFromRoute(route);
    let exists: Observable<boolean> = of(false);

    if (alias) {
      exists = this.tenantService.tenantExists(alias).pipe(
        map(exists => {
          if (!exists)
            this.router.navigate(['login']); // not found-page??
          return exists
        }), catchError(() =>
          this.router.navigate(['login']) // error page??
        )
      );

      return exists;
    }
    else {
      // No tenant found. Show some info page?
      this.router.navigate(['login']);
      return of(false);
    }
  }
}
